import { getCtaText } from '@nerdwallet/marketplace/selectors/common';
export default (function (_ref) {
  var marketplaceEntity = _ref.marketplaceEntity;
  return {
    // there's no Software impression event, so don't log impressions
    logImpression: false,
    text: getCtaText(marketplaceEntity) || 'Shop Now'
  };
});